<template>
  <div class="offsite">
    <div class="reserve-form">
      <div class="menu">
        <div
          class="item"
          @click="openRegion()"
        >{{ searchForm.region ? searchForm.region : '区域' }}<van-icon name="arrow-down" /></div>
        <div
          class="item"
          @click="openUser()"
        >{{ searchForm.personName ? searchForm.personName : '销售' }}<van-icon name="arrow-down" /></div>
      </div>
      <van-search
        v-model="searchForm.canSellId"
        placeholder="会销场次ID"
        show-action
      >
        <template #action>
          <div @click="getList">搜索</div>
        </template>
      </van-search>
    </div>
    <!-- 汇总按钮栏 -->
    <div class="date-label">
      <div
        class="label"
        v-for="(date, i) in dateList"
        :class="{'active': activeDateIndex === i}"
        :key="i"
        @click="changeDate(date, i)"
      >{{ date.label }}</div>
    </div>
    <van-form v-if="activeDateIndex === 0">
      <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="searchForm.dateString"
        right-icon="arrow"
        label="自定义日期"
        placeholder="点击选择日期"
        @click="dateShow = true"
      />
      <van-calendar
        v-if="dateShow"
        v-model="dateShow"
        color="#e7635e"
        :min-date="new Date('2010-12-21')"
        :default-date="searchForm.date"
        :allow-same-day="true"
        @confirm="onDateConfirm"
        type="range"
        :style="{ height: '600px' }"
      />
    </van-form>
    <div
      class="total"
      v-if="regionData.totalsSessions"
    >
      <p>总场次：{{ regionData.totalsSessions }}，送检人数:{{ regionData.examineCount }}，实际应收金额：{{ regionData.orderReceivableAmount }},回款金额：{{ regionData.returnedAmount }}。</p>
      <p>其中，<span
          v-for="(item,i) in regionData.regionList"
          :key="i"
        >
          {{ item.region }}({{ item.regiontTotals }}，{{ item.examineCount }}，{{ item.orderReceivableAmount }}，{{ item.returnedAmount }})；
        </span></p>
    </div>
    <!-- 日历部分 -->
    <div
      class="offsite-content"
      v-if="!isLoading"
    >
      <div class="date">
        <van-calendar
          :title="dateTitle"
          type="single"
          :poppable="false"
          :show-subtitle="false"
          :min-date="minDate"
          :max-date="maxDate"
          :show-confirm="false"
          :style="{ height: '100%' }"
        >
          <template #bottom-info="date">
            <div class="date-cell">
              <div
                v-for="(info,i) in getDateInfo(date.date)"
                :key="i"
              >
                <p
                  class="date-info"
                  @click="addDetail(info)"
                >{{ info.label }}</p>
                <!-- <template v-if="today <= moment(date.date).format('YYYY-MM-DD') && info.available != 0">
                  <p
                    class="plus-icon"
                    @click="addEvent(date)"
                  >+</p>
                </template> -->
              </div>
              <!-- 本地会销容量剩余 && 今天之后的日期 && 周日 -->
              <template v-if="plusHide(date.date) && today <= moment(date.date).format('YYYY-MM-DD') && sunday(date)">
                <p
                  class="plus-icon"
                  @click="addEvent(date)"
                >+</p>
              </template>
            </div>
          </template>
        </van-calendar>
      </div>
    </div>
    <div class="tabbar">
      <div
        class="item"
        v-for="(item, i) in canSellTypeList"
        :key="i"
        :class="{'active':  activeIndex === i}"
        @click="changActive(i, item.key)"
      >
        {{ item.value }}
      </div>
    </div>
    <CheckPicker
      :show="showTypePicker"
      :value="checkAll"
      :type="showType"
      :columns="columns"
      @confirm="confirmPicker"
      @cancel="cancelPicker"
      @search="searchPicker"
    />
  </div>
</template>

<script>
import { Toast } from "vant";
import moment from "moment";
import getUserInfo from "@/models/userInfo";
import offsiteService from "@/apis/offsite/index.js";
import CheckPicker from "@/components/CheckPicker/index.vue";
import * as dd from "dingtalk-jsapi";
export default {
  components: {
    CheckPicker,
  },
  data() {
    return {
      currentUserInfo: {},
      // 销售列表
      salesList: [],
      departmentList: [],
      // 搜索选择框
      showType: "",
      showTypePicker: false,
      columns: [],
      checkAll: [],
      // 日期
      dateShow: false,
      activeDateIndex: 2,
      dateList: [
        {
          label: "自定义汇总日期",
          title: "自定义汇总日期",
          date: [],
        },
        {
          label: "本年汇总",
          title: "本年汇总",
          date: [
            moment().startOf("year").format("YYYY-MM-DD"),
            moment().endOf("year").format("YYYY-MM-DD"),
          ],
        },
        {
          label: moment().format("MM") + "月汇总",
          title: moment().format("YYYY年MM月"),
          date: [
            moment().startOf("month").format("YYYY-MM-DD"),
            moment().add(1, "M").endOf("month").format("YYYY-MM-DD"),
          ],
        },
        {
          label: moment().subtract(1, "months").format("MM") + "月汇总",
          title: moment().subtract(1, "months").format("YYYY年MM月"),
          date: [
            moment()
              .subtract(1, "months")
              .startOf("month")
              .format("YYYY-MM-DD"),
            moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
          ],
        },
        {
          label: moment().subtract(2, "months").format("MM") + "月汇总",
          title: moment().subtract(2, "months").format("YYYY年MM月"),
          date: [
            moment()
              .subtract(2, "months")
              .startOf("month")
              .format("YYYY-MM-DD"),
            moment().subtract(2, "months").endOf("month").format("YYYY-MM-DD"),
          ],
        },
        {
          label: moment().subtract(3, "months").format("MM") + "月汇总",
          title: moment().subtract(3, "months").format("YYYY年MM月"),
          date: [
            moment()
              .subtract(3, "months")
              .startOf("month")
              .format("YYYY-MM-DD"),
            moment().subtract(3, "months").endOf("month").format("YYYY-MM-DD"),
          ],
        },
      ],
      // 日历面板
      isLoading: false,
      dateTitle: "",
      today: moment().format("YYYY-MM-DD"),
      minDate: new Date(moment().startOf("month").format("YYYY-MM-DD")),
      maxDate: new Date(
        moment().add(1, "M").endOf("month").format("YYYY-MM-DD")
      ),
      searchForm: {
        canSellId: "",
        region: "",
        personName: "",
        canSellType: "remote",
        dateString: "",
        date: [
          new Date(moment().startOf("month").format("YYYY-MM-DD")),
          new Date(moment().add(1, "M").endOf("month").format("YYYY-MM-DD")),
        ],
      },
      regionData: {},
      // 模拟会销数据，结构为 { 日期: [ { 区域: 'xx', 人次: xx } ] }
      meetingData: {},
      // tabbar
      canSellTypeList: [
        {
          key: "remote",
          value: "异地会销",
        },
        {
          key: "local",
          value: "本地会销",
        },
      ],
      activeIndex: 0,
    };
  },
  watch: {
    searchForm: {
      handler(newVal) {
        this.searchForm.dateString = `${moment(newVal.date[0]).format(
          "YYYY-MM-DD"
        )}至${moment(newVal.date[1]).format("YYYY-MM-DD")}`;
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    dd.biz.navigation.setTitle({
      title: "会销预约", //控制标题文本，空字符串表示显示默认文本
    });
    this.dateTitle = this.dateList[2].title;
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getUser();
    this.getList();
  },
  methods: {
    moment,
    changActive(index, val) {
      this.activeIndex = index;
      this.searchForm.canSellType = val;
      this.getList();
    },
    getUser() {
      offsiteService.getUserApi(this.currentUserInfo.user_id).then((res) => {
        this.salesList = res.data.nameList;
        this.departmentList = res.data.directionList;
        // this.canSellTypeList = res.data.canSellTypeList
      });
    },
    openRegion() {
      if (this.departmentList.length === 0) {
        Toast("数据加载中，请稍等！");
        return;
      }
      this.checkAll = this.searchForm.region
        ? this.searchForm.region.split(",")
        : [];
      this.columns = this.departmentList;
      this.showType = "region";
      this.showTypePicker = true;
    },
    openUser() {
      if (this.salesList.length === 0) {
        Toast("数据加载中，请稍等！");
        return;
      }
      this.checkAll = this.searchForm.personName
        ? this.searchForm.personName.split(",")
        : [];
      this.columns = this.salesList;
      this.showType = "user";
      this.showTypePicker = true;
    },
    confirmPicker(value) {
      switch (this.showType) {
        case "region":
          this.searchForm.region = value.join(",");
          break;
        case "user":
          this.searchForm.personName = value.join(",");
          break;
        default:
          break;
      }
      this.showTypePicker = false;
      this.getList();
    },
    cancelPicker() {
      this.showTypePicker = false;
    },
    searchPicker(val) {
      if (this.showType === "region") {
        this.columns = this.departmentList.filter((item) =>
          item.name.includes(val)
        );
      } else {
        this.columns = this.salesList.filter((item) => item.name.includes(val));
      }
    },
    changeDate(value, i) {
      this.activeDateIndex = i;
      this.dateTitle = value.title;
      this.meetingData = {};
      if (i === 0) {
        this.minDate = new Date(moment().startOf("month").format("YYYY-MM-DD"));
        this.maxDate = new Date(moment().endOf("month").format("YYYY-MM-DD"));
        this.searchForm.date = [
          new Date(moment().startOf("month").format("YYYY-MM-DD")),
          new Date(moment().endOf("month").format("YYYY-MM-DD")),
        ];
      } else {
        this.minDate = new Date(value.date[0]);
        this.maxDate = new Date(value.date[1]);
        this.searchForm.date = value.date;
      }
      this.getList();
    },
    // 日期选择确认
    onDateConfirm(date) {
      this.meetingData = {};
      this.searchForm.date = date;
      this.minDate = new Date(moment(date[0]).format("YYYY-MM-DD"));
      this.maxDate = new Date(moment(date[1]).format("YYYY-MM-DD"));
      this.dateShow = false;
      this.getList();
    },
    // 获取日期对应的会销信息
    getDateInfo(date) {
      const dateStr = moment(date).format("YYYY-MM-DD");
      if (!this.meetingData) return;
      return (
        this.meetingData[dateStr]?.map((i) => {
          return {
            ...i,
            label: i.regionName + i.cardNum,
          };
        }) || []
      );
    },
    plusHide(date) {
      if (this.searchForm.canSellType === "remote") {
        return true;
      }
      const dateStr = moment(date).format("YYYY-MM-DD");
      const hide = this.meetingData[dateStr] || [];
      return hide[0]?.available == 0 ? false : true;
    },
    sunday(date) {
      if (this.searchForm.canSellType === "remote") {
        return true;
      } else {
        return moment(date.date).day() !== 0;
      }
    },
    getList() {
      this.isLoading = true;
      offsiteService
        .getCanSellTimeListApi({
          ...this.searchForm,
          startTime: moment(this.searchForm.date[0]).format("YYYY-MM-DD"),
          endTime: moment(this.searchForm.date[1]).format("YYYY-MM-DD"),
          timeType: this.activeDateIndex === 0 || this.activeDateIndex === 1 ? '' : 1
        })
        .then((res) => {
          this.isLoading = false;
          if (res.code === 200) {
            this.regionData = res.data.region;
            this.meetingData = res.data.listTime;
          } else {
            Toast("数据获取错误！");
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    // 添加会销事件
    addEvent(date) {
      const dateStr = moment(date.date).format("YYYY-MM-DD");
      this.$router.push({
        name: "OffsiteAdd",
        query: {
          date: dateStr,
          canSellType: this.searchForm.canSellType,
        },
      });
    },
    addDetail(val) {
      this.$router.push({
        name: "OffsiteDetail",
        query: {
          date: val.bookTime,
          id: val.canSellId,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.offsite {
  .offsite-content {
    flex: 1;
    overflow-y: auto;
    // .van-calendar__body {
    //   overflow: hidden;
    // }
  }
  .van-calendar__day {
    display: block;
    min-height: 44px;
    height: auto;
  }
  .van-calendar__bottom-info {
    position: static;
  }
  .van-calendar__selected-day {
    display: block;
    height: auto;
    background: transparent;
  }
  .van-calendar__selected-day {
    color: #2c3e50;
  }
}
</style>
<style lang="scss" scoped>
.offsite {
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);
  .tabbar {
    width: 100%;
    height: 60px;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    background-color: #fff;
    .item {
      flex: 1;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .active {
      color: #e7635e;
      background-color: #fcf0f0;
    }
  }
  .reserve-form {
    .menu {
      display: flex;
      align-items: center;
      gap: 10px;
      border-bottom: 1px solid #e3e3e3;
      .item {
        padding: 10px 0;
        width: 50%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 14px;
        text-align: center;
        border-right: 1px solid #e3e3e3;
        &:last-child {
          border-right: none;
        }
      }
    }
  }
  .date-label {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    .label {
      padding: 6px;
      border-radius: 20px;
      border: 1px solid #ccc;
      font-size: 14px;
      display: inline-block;
      margin-right: 10px;
    }
    .active {
      color: #e7635e;
      border-color: #e7635e;
    }
  }
  .total {
    margin: 10px 10px 0;
    font-size: 14px;
    height: 80px;
    overflow-y: auto;
    p {
      margin: 0;
    }
  }
  // &-content {
  //   height: 70%;
  //   .date {
  //     overflow-y: auto;
  //     height: 100%;
  //   }
  // }
  // &-content2 {
  //   height: 65%;
  //   .date {
  //     overflow-y: auto;
  //     height: 100%;
  //   }
  // }
}
.date-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.date-info {
  padding: 2px 4px;
  border-radius: 2px;
  margin: 0 0 2px 0;
  background: rgb(237, 248, 252);
  &:nth-child(2n) {
    background: rgb(231, 253, 241);
  }
  &:nth-child(3n) {
    background: #fcf6e8;
  }
}
.plus-icon {
  width: 10px;
  background-color: #0066cc;
  color: white;
  padding: 4px 10px;
  border-radius: 4px;
  margin: 0 auto;
  cursor: pointer;
}
</style>